module.exports = __webpack_public_path__ + "static/img/Hussar_development-face.1b4d1fe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/Hussar_development-face.webp
// module id = B6Di
// module chunks = 0